document.addEventListener('DOMContentLoaded', () => {
    const tableOfContentsButton = document.querySelector('[data-component="toc-toggle-hero"]');
    const tableOfContentsPanel = document.querySelector('[data-component="toc-content"]');
    const stickyNavigation = document.querySelector('.c-featured-sticky');
    const tocContainer = document.querySelector('[data-toc]');
    const mobileTableOfContents = document.querySelector('.mobile-toc');

    if (!tableOfContentsButton || !tableOfContentsPanel) {
        return;
    }

    let hasTocBeenVisible = false;
    let previousScrollPosition = window.scrollY;

    if (tocContainer && stickyNavigation) {
        tocContainer.style.minHeight = stickyNavigation.offsetHeight + 'px';
    }

    tableOfContentsButton.addEventListener('click', () => {
        tableOfContentsButton.classList.toggle('toggled');
        tableOfContentsPanel.classList.toggle('is-open');
    });

    const visibilityObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            const currentScrollPosition = window.scrollY;
            if (entry.isIntersecting) {
                mobileTableOfContents?.classList.remove('is-visible');
                hasTocBeenVisible = true;
            } else if (hasTocBeenVisible && currentScrollPosition > previousScrollPosition) {
                mobileTableOfContents?.classList.add('is-visible');
            } else if (currentScrollPosition < previousScrollPosition) {
                mobileTableOfContents?.classList.remove('is-visible');
            }
            previousScrollPosition = currentScrollPosition;
        });
    }, {
        root: null,
        threshold: 0
    });

    visibilityObserver.observe(tableOfContentsButton);
    checkInitialVisibility();

    function checkInitialVisibility() {
        const buttonPosition = tableOfContentsButton.getBoundingClientRect();
        if (buttonPosition.top >= 0 && buttonPosition.bottom <= window.innerHeight) {
            mobileTableOfContents?.classList.remove('is-visible');
        } else if (buttonPosition.top < 0 || buttonPosition.bottom > window.innerHeight) {
            if (window.scrollY > buttonPosition.bottom) {
                hasTocBeenVisible = true;
                mobileTableOfContents?.classList.add('is-visible');
            } else {
                mobileTableOfContents?.classList.remove('is-visible');
                hasTocBeenVisible = false;
            }
        }
    }
});
